import { render } from "./Video.vue?vue&type=template&id=61ed5d1c&scoped=true&bindings={}"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"

import "./Video.vue?vue&type=style&index=0&id=61ed5d1c&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-61ed5d1c"

export default script